import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DepartmentsComponent } from './departments.component';
import { DepartmentComponent } from './department/department.component';
import { DepartmentInfoComponent } from './department-info/department-info.component';
import { DepartmentsRoutingModule } from './departments-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BBSFControlsModule } from 'bbsf-controls';
import { BlockUIModule } from 'ng-block-ui';
// import { environmentService } from '../shared/Services/environmentsService.Service';
import { DataSecretService } from '../shared/Services/data.service';
import { NgbModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { AuthService, EnvironmentService, UtilityService, BBSFTranslateService } from 'bbsf-utilities';
import { EmptyDataModule } from '../empty-data/empty-data.module';
@NgModule({
  declarations: [DepartmentsComponent, DepartmentComponent, DepartmentInfoComponent],
  imports: [
    DepartmentsRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    NgbModule,
    MatMenuModule,
    InlineSVGModule,   
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    DataSecretService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    

  ]
})
export class DepartmentsModule { }
